module.exports = __webpack_public_path__ + "static/vampire_lord-5564ab29cf0666c3792123711a8be9ce.jpg";